import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { OrganizationBillingFacade } from '../../../../../Facades/Organizations/organization-billing.facade';
import { DATE_TIME_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { BILLING_DOCUMENTS_LINK_LABEL } from '../../../../../Consts/billing.const';
import { PAYMENT_STATUS_LABEL, PAYMENT_STATUS_OPTIONS } from '../../../../../Enums/stripe-status.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'av-organization-payments',
  standalone: true,
  imports: [
    RouterLink,
    DatePipe,
    DecimalPipe,
    MatIconModule,
    AvEmptyStateComponent,
    AvPaginatorComponent,
    AvStatusChipComponent,
    TranslateModule,
  ],
  templateUrl: './organization-payments.component.html',
  styleUrl: './organization-payments.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class OrganizationPaymentsComponent {
  readonly facade = inject(OrganizationBillingFacade);

  readonly organizationId = input<string>('');

  readonly dateTimeFormat = DATE_TIME_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;
  readonly documentsLinkLabel = BILLING_DOCUMENTS_LINK_LABEL;
  readonly statusOptions = PAYMENT_STATUS_OPTIONS;
  readonly statusLabelKeys = PAYMENT_STATUS_LABEL;

  readonly isEmpty = computed<boolean>(
    () => this.facade.paymentsState() === 'ready' && this.facade.payments().length === 0,
  );

  filterStatus(value: string): void {
    this.facade.filterPayments(value);
  }

  goToPage(page: number): void {
    this.facade.goToPaymentPage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }
}
